import React from 'react';
import { UseFormRegister } from 'react-hook-form';
import { InvoiceHire } from '../../types';

interface InvoiceHireSocialInsuranceProps {
  register: UseFormRegister<InvoiceHire>;
}

const inputStyle = {
  backgroundColor: '#fef3e2',
  borderColor: '#8b4513',
};

const InvoiceHireSocialInsurance: React.FC<InvoiceHireSocialInsuranceProps> = ({
  register,
}) => {
  return (
    <div className="card" style={{ backgroundColor: '#f4f1e8', borderColor: '#8b4513' }}>
      <div className="card-header" style={{ backgroundColor: '#8b4513', color: 'white' }}>
        <h2 className="text-lg font-semibold text-white">Social Insurance - التأمينات الاجتماعية</h2>
      </div>
      <div className="card-body">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Insurance Status - موقف التأمينات
            </label>
            <select
              {...register('socialInsurance.insuranceStatus')}
              className="w-full px-3 py-2 border border-amber-700 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-amber-500 bg-amber-50"
              style={inputStyle}
            >
              <option value="not_received">لم يستلم - Not Received</option>
              <option value="in_progress">جاري - In Progress</option>
              <option value="completed">تم - Completed</option>
            </select>
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Client Delivery Date - تاريخ تسليمه الى العميل
            </label>
            <input
              type="date"
              {...register('socialInsurance.clientDeliveryDate')}
              className="w-full px-3 py-2 border border-amber-700 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-amber-500 bg-amber-50"
              style={inputStyle}
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Insurance Delivery Date - تاريخ التسليم الى التأمينات
            </label>
            <input
              type="date"
              {...register('socialInsurance.insuranceDeliveryDate')}
              className="w-full px-3 py-2 border border-amber-700 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-amber-500 bg-amber-50"
              style={inputStyle}
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Certificate Number - رقم الشهادة
            </label>
            <input
              type="text"
              {...register('socialInsurance.certificateNumber')}
              className="w-full px-3 py-2 border border-amber-700 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-amber-500 bg-amber-50"
              style={inputStyle}
              placeholder="Certificate number"
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Certificate Value - قيمة الشهادة
            </label>
            <input
              type="number"
              step="0.01"
              min="0"
              {...register('socialInsurance.certificateValue')}
              className="w-full px-3 py-2 border border-amber-700 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-amber-500 bg-amber-50"
              style={inputStyle}
              placeholder="0.00"
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Client Receipt Date - تاريخ استلام الإخطاب من العميل
            </label>
            <input
              type="date"
              {...register('socialInsurance.clientReceiptDate')}
              className="w-full px-3 py-2 border border-amber-700 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-amber-500 bg-amber-50"
              style={inputStyle}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvoiceHireSocialInsurance;
